module.exports = __webpack_public_path__ + "static/5-8debb3852b36ad09ddd37146dc36b7a2.jpg";